"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnArticle = void 0;
exports.columnArticle = {
    modalMessage: `專欄計畫籌備中，歡迎投稿！

    `,
};
